var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _path16, _g13, _path17, _g14, _path18, _path19, _path20, _path21, _path22, _path23, _g15, _path24, _g16, _path25, _g17, _path26, _g18, _path27, _g19, _path28, _g20, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g21, _path41, _g22, _path42, _path43, _g23, _path44, _g24, _path45, _path46, _path47, _path48, _g25, _path49, _path50, _g26, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortuneWheelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 328,
    viewBox: "0 0 328 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.484 302.858C265.173 289.335 316.38 216.205 302.858 139.516C289.336 62.8265 216.205 11.6197 139.516 25.1421C62.8265 38.6644 11.6197 111.795 25.1421 188.484C38.6645 265.173 111.795 316.38 188.484 302.858Z",
    fill: "#FFCE00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 284,
    height: 284
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.484 302.858C265.173 289.335 316.38 216.205 302.858 139.516C289.336 62.8265 216.205 11.6197 139.516 25.1421C62.8265 38.6644 11.6197 111.795 25.1421 188.484C38.6645 265.173 111.795 316.38 188.484 302.858Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_141_180)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.283 7.30126C134.325 61.087 60.0895 144.567 17.446 242.183C7.71073 225.409 -1.32655 206.117 -5.58333 187.198C27.5981 133.058 106.007 31.0507 193.417 -5.91024C196.191 -7.09922 199.383 -5.08358 202.325 -4.27626C205.529 -3.44158 208.507 -2.01436 211.543 -0.671179C216.22 1.414 220.973 3.30167 225.837 4.98552C226.02 4.76911 226.106 7.5534 226.283 7.30126Z",
    fill: "#FFEB97"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 284,
    height: 284
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188.484 302.858C265.173 289.335 316.38 216.205 302.858 139.516C289.336 62.8265 216.205 11.6197 139.516 25.1421C62.8265 38.6644 11.6197 111.795 25.1421 188.484C38.6645 265.173 111.795 316.38 188.484 302.858Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_141_180)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.601 91.4913C253.091 150.354 196.37 216.601 148.004 288.448C136.093 306.129 123.086 325.734 113.639 344.86C106.662 340.381 99.5197 336.225 92.2012 332.322C89.3184 330.804 86.3999 329.293 83.29 328.368C80.9933 327.668 78.5621 327.25 76.3937 326.232C74.5846 325.373 72.9499 324.04 71.0126 323.498C69.5417 323.094 67.9972 323.108 66.459 323.159C64.2589 323.215 61.9202 322.486 59.7201 322.542C116.83 216.518 196.335 122.606 291.475 48.8474C299.5 62.6081 308.576 77.7306 316.601 91.4913Z",
    fill: "#FFEB97"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 284,
    height: 284
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.484 302.858C265.173 289.335 316.38 216.205 302.858 139.516C289.336 62.8265 216.205 11.6197 139.516 25.1421C62.8265 38.6644 11.6197 111.795 25.1421 188.484C38.6645 265.173 111.795 316.38 188.484 302.858Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_141_180)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.594 10.4716C108.121 58.7087 50.0187 123.174 9.30752 197.28C11.7928 201.557 14.0133 206.212 16.4628 210.495C53.6399 149.351 99.2298 94.3483 149.667 43.6479C160.053 33.1973 170.769 22.9463 182.91 14.5069C181.143 13.0505 179.874 10.6589 177.594 10.4716Z",
    fill: "#FFEFAB"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 284,
    height: 284
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.484 302.858C265.173 289.335 316.38 216.205 302.858 139.516C289.336 62.8265 216.205 11.6197 139.516 25.1421C62.8265 38.6644 11.6197 111.795 25.1421 188.484C38.6645 265.173 111.795 316.38 188.484 302.858Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_141_180)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.848 60.1104C207.021 117.407 92.0475 301.998 87.3053 313.332C89.9402 314.488 102.43 322.231 105.064 323.387C107.198 316.27 211.264 143.769 310.065 81.9989C308.807 77.5796 304.284 64.6746 303.848 60.1104Z",
    fill: "#FFEFAB"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "#FFDF99"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 164L142.294 40.899L153.751 35.007L191.133 38.421L191.782 42.1018L164 164Z",
    fill: "#FF4AE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 164L240.552 57.9985L274.113 97.3166L271.119 99.5312L164 164Z",
    fill: "#FF4AE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 164L290.059 141.772L293.892 193.463L289.154 192.956L164 164Z",
    fill: "#FF4AE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 164L234.769 274.501L270.619 236.745L164 164Z",
    fill: "#FF4AE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 164L136.447 287.621L164.826 294.386L186.336 289.405L164 164Z",
    fill: "#FF4AE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1729 269.26L164 164L53.5498 230.666L88.1729 269.26Z",
    fill: "#FF4AE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1906 186.398L164 164L33.6753 133.77L37.1906 186.398Z",
    fill: "#FF4AE5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 252,
    height: 252
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M185.706 287.101C253.693 275.113 299.089 210.281 287.101 142.294C275.113 74.3071 210.281 28.9111 142.294 40.899C74.3073 52.8869 28.9112 117.719 40.8991 185.706C52.887 253.693 117.719 299.089 185.706 287.101Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4859 92.2256L164 164L93.864 54.3455L59.4859 92.2256Z",
    fill: "#FF4AE5"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.966 213.081C191.008 213.081 212.931 191.125 212.931 164.04C212.931 136.956 191.008 115 163.966 115C136.923 115 115 136.956 115 164.04C115 191.125 136.923 213.081 163.966 213.081Z",
    fill: "#FFCE00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 115,
    width: 98,
    height: 99
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.966 213.081C191.008 213.081 212.931 191.125 212.931 164.04C212.931 136.956 191.008 115 163.966 115C136.923 115 115 136.956 115 164.04C115 191.125 136.923 213.081 163.966 213.081Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_141_180)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.82 123.431C197.05 137.458 172.825 154.357 150.732 173.723C139.777 183.333 128.749 193.641 120.294 205.533C118.786 203.913 117.316 202.293 115.809 200.637C111.471 195.924 107.354 190.475 104.009 185.026C125.293 154.21 157.128 132.23 190.323 114.963C193.191 113.491 196.058 112.018 198.815 110.435C204.035 115 210.578 118.608 216.828 121.627C218.739 122.511 220.761 123.836 222.82 123.431Z",
    fill: "#FFEB97"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 115,
    width: 98,
    height: 99
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M163.966 213.081C191.008 213.081 212.931 191.125 212.931 164.04C212.931 136.956 191.008 115 163.966 115C136.923 115 115 136.956 115 164.04C115 191.125 136.923 213.081 163.966 213.081Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_141_180)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.172 167.869C198.521 184.363 174.553 206.122 155.841 231.268C150.143 227.844 144.592 223.021 139.225 219.045C162.458 191.064 190.691 167.317 222.195 149.203C224.364 155.02 226.018 161.721 225.172 167.869Z",
    fill: "#FFEB97"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M142.624 181.286C145.731 181.286 148.249 178.583 148.249 175.248C148.249 171.914 145.731 169.21 142.624 169.21C139.518 169.21 137 171.914 137 175.248C137 178.583 139.518 181.286 142.624 181.286Z",
    fill: "#F2B297"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M142.845 178.488C144.774 178.488 146.337 177.087 146.337 175.359C146.337 173.63 144.774 172.229 142.845 172.229C140.916 172.229 139.353 173.63 139.353 175.359C139.353 177.087 140.916 178.488 142.845 178.488Z",
    fill: "#CA463F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.267 181.286C188.373 181.286 190.891 178.583 190.891 175.248C190.891 171.914 188.373 169.21 185.267 169.21C182.161 169.21 179.643 171.914 179.643 175.248C179.643 178.583 182.161 181.286 185.267 181.286Z",
    fill: "#E7986D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185.046 178.488C186.975 178.488 188.539 177.087 188.539 175.359C188.539 173.63 186.975 172.229 185.046 172.229C183.118 172.229 181.554 173.63 181.554 175.359C181.554 177.087 183.118 178.488 185.046 178.488Z",
    fill: "#CA463F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 166.118L143.764 164.682V180.587C143.764 190.564 151.851 198.664 161.814 198.664H163.946H164.203H166.335C176.297 198.664 184.385 190.564 184.385 180.587V164.682L164.093 166.118Z",
    fill: "#E7986D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 164,
    width: 42,
    height: 35
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 166.118L143.764 164.682V180.587C143.764 190.564 151.851 198.664 161.814 198.664H163.946H164.203H166.335C176.297 198.664 184.385 190.564 184.385 180.587V164.682L164.093 166.118Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.468 188.797C165.453 190.306 168.026 191.227 170.489 190.675C169.938 190.417 169.386 190.159 168.872 189.901C168.283 189.607 167.658 189.349 167.107 188.981C166.262 188.466 165.526 187.766 164.681 187.251C164.387 187.067 164.056 186.919 163.725 186.956C163.357 187.03 163.1 187.324 162.88 187.582C162.365 188.171 161.814 188.723 161.152 189.202C160.564 189.644 159.792 189.865 159.24 190.306C159.718 190.601 160.747 190.196 161.225 190.012C162.034 189.754 162.806 189.312 163.468 188.797Z",
    fill: "#D05244"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 164,
    width: 42,
    height: 35
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 166.118L143.764 164.682V180.587C143.764 190.564 151.851 198.664 161.814 198.664H163.946H164.203H166.335C176.297 198.664 184.385 190.564 184.385 180.587V164.682L164.093 166.118Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M147.366 182.501C147.808 182.354 148.249 182.28 148.653 182.133C149.719 181.691 150.454 180.697 151.006 179.666C153.064 175.874 153.395 171.419 153.395 167.112C153.395 166.596 153.395 166.081 153.175 165.602C152.844 164.829 152.035 164.387 151.263 164.056C149.903 163.467 148.432 163.099 146.962 162.915C146.447 162.841 145.896 162.841 145.418 163.025C145.05 163.209 144.72 163.504 144.499 163.835C143.47 165.234 143.212 167.112 143.102 168.842C142.735 174.107 143.029 179.409 143.58 184.673C143.764 186.33 144.426 184.673 144.793 184.195C145.455 183.422 146.374 182.796 147.366 182.501Z",
    fill: "#F2B297"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 164,
    width: 42,
    height: 35
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 166.118L143.764 164.682V180.587C143.764 190.564 151.851 198.664 161.814 198.664H163.946H164.203H166.335C176.297 198.664 184.385 190.564 184.385 180.587V164.682L164.093 166.118Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.468 169.21C177.781 169.21 189.384 167.117 189.384 164.535C189.384 161.952 177.781 159.859 163.468 159.859C149.154 159.859 137.551 161.952 137.551 164.535C137.551 167.117 149.154 169.21 163.468 169.21Z",
    fill: "#D96955"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 164,
    width: 42,
    height: 35
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 166.118L143.764 164.682V180.587C143.764 190.564 151.851 198.664 161.814 198.664H163.946H164.203H166.335C176.297 198.664 184.385 190.564 184.385 180.587V164.682L164.093 166.118Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M143.58 181.802C143.617 182.244 143.727 182.833 144.095 182.869C144.646 182.501 144.683 181.47 144.609 180.66C144.426 178.378 144.279 176.021 144.609 173.776C144.72 172.929 144.756 171.382 143.764 171.64C143.065 171.787 143.176 172.782 143.212 173.481C143.212 176.279 143.323 179.04 143.58 181.802Z",
    fill: "#F9CBBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 164,
    width: 42,
    height: 35
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 166.118L143.764 164.682V180.587C143.764 190.564 151.851 198.664 161.814 198.664H163.946H164.203H166.335C176.297 198.664 184.385 190.564 184.385 180.587V164.682L164.093 166.118Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M166.776 191.926C166.188 192.442 165.379 192.736 164.607 192.81C163.835 192.884 163.027 192.81 162.218 192.663C161.703 192.589 161.152 192.479 160.711 192.147C160.564 192.037 160.343 192.184 160.233 192.331C160.159 192.479 160.159 192.663 160.233 192.81C160.38 193.289 160.895 193.546 161.336 193.73C162.916 194.319 164.718 194.209 166.262 193.51C166.629 193.325 166.997 193.105 167.144 192.736C167.254 192.368 167.144 191.963 166.776 191.926Z",
    fill: "#D96955"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 164,
    width: 42,
    height: 35
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 166.118L143.764 164.682V180.587C143.764 190.564 151.851 198.664 161.814 198.664H163.946H164.203H166.335C176.297 198.664 184.385 190.564 184.385 180.587V164.682L164.093 166.118Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M156.226 180.219C157.255 180.034 158.211 179.445 158.689 178.525C158.946 178.01 159.057 177.42 159.13 176.831C159.167 176.611 159.167 176.316 158.983 176.169C158.836 176.353 158.726 176.61 158.652 176.868C158.248 177.825 157.476 178.672 156.557 179.188C155.638 179.703 154.535 179.887 153.469 179.74C153.065 179.666 153.212 179.924 153.469 179.998C153.763 180.108 154.094 180.182 154.388 180.219C154.976 180.329 155.601 180.329 156.226 180.219Z",
    fill: "#D96955"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M154.572 179.998C157.191 179.998 159.314 177.937 159.314 175.395C159.314 172.854 157.191 170.793 154.572 170.793C151.953 170.793 149.83 172.854 149.83 175.395C149.83 177.937 151.953 179.998 154.572 179.998Z",
    fill: "#FDFCFC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M154.645 178.746C156.391 178.746 157.807 177.378 157.807 175.69C157.807 174.002 156.391 172.634 154.645 172.634C152.899 172.634 151.484 174.002 151.484 175.69C151.484 177.378 152.899 178.746 154.645 178.746Z",
    fill: "#09122E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M153.395 175.469C153.903 175.469 154.314 175.057 154.314 174.549C154.314 174.04 153.903 173.628 153.395 173.628C152.888 173.628 152.476 174.04 152.476 174.549C152.476 175.057 152.888 175.469 153.395 175.469Z",
    fill: "#FDFCFC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M149.793 169.431C149.866 168.989 150.16 168.621 150.455 168.327C151.484 167.333 152.917 166.817 154.314 166.449C154.682 166.338 155.086 166.228 155.491 166.228C155.748 166.228 156.042 166.302 156.3 166.375C156.704 166.486 157.071 166.633 157.439 166.817C157.843 167.038 158.211 167.296 158.468 167.664C158.652 167.922 158.762 168.253 158.689 168.548C158.579 168.916 158.248 169.137 157.88 169.247C157.513 169.321 157.145 169.284 156.777 169.284C154.903 169.173 152.991 169.615 151.337 170.499C150.969 170.683 150.528 170.904 150.197 170.572C149.903 170.278 149.719 169.836 149.793 169.431Z",
    fill: "#1F4278"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.916 180.145C175.535 180.145 177.658 178.085 177.658 175.543C177.658 173.001 175.535 170.941 172.916 170.941C170.296 170.941 168.173 173.001 168.173 175.543C168.173 178.085 170.296 180.145 172.916 180.145Z",
    fill: "#FDFCFC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M172.805 178.893C174.551 178.893 175.967 177.525 175.967 175.837C175.967 174.15 174.551 172.781 172.805 172.781C171.059 172.781 169.644 174.15 169.644 175.837C169.644 177.525 171.059 178.893 172.805 178.893Z",
    fill: "#09122E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.033 175.616C172.541 175.616 172.952 175.204 172.952 174.696C172.952 174.188 172.541 173.776 172.033 173.776C171.526 173.776 171.114 174.188 171.114 174.696C171.114 175.204 171.526 175.616 172.033 175.616Z",
    fill: "#FDFCFC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M177.694 169.578C177.621 169.137 177.327 168.768 177.033 168.474C176.003 167.48 174.57 166.964 173.173 166.596C172.805 166.486 172.401 166.375 171.996 166.375C171.739 166.375 171.445 166.449 171.188 166.523C170.783 166.633 170.416 166.78 170.048 166.964C169.644 167.185 169.276 167.443 169.019 167.811C168.835 168.069 168.725 168.4 168.798 168.695C168.908 169.063 169.239 169.284 169.607 169.394C169.975 169.468 170.342 169.431 170.71 169.431C172.585 169.321 174.496 169.762 176.15 170.646C176.518 170.83 176.959 171.051 177.29 170.72C177.584 170.425 177.768 169.983 177.694 169.578Z",
    fill: "#1F4278"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M142.404 168.879C142.367 169.505 142.367 170.167 142.477 170.793C142.588 171.419 142.845 172.045 143.323 172.487C143.617 172.745 143.985 172.966 144.352 172.966C145.014 172.966 145.528 172.487 145.933 171.971C146.742 170.941 147.256 169.726 147.697 168.474C147.955 167.774 148.212 167.075 148.286 166.338C148.322 166.081 148.322 165.823 148.212 165.602C148.139 165.381 147.955 165.234 147.771 165.124C146.999 164.534 145.97 164.314 144.977 164.203C144.609 164.166 144.242 164.129 143.874 164.166C143.396 164.203 143.029 164.24 142.882 164.719C142.735 165.16 142.624 165.639 142.551 166.081C142.477 167.001 142.441 167.922 142.404 168.879Z",
    fill: "#FDFCFC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M185.561 168.805C185.598 169.431 185.598 170.094 185.488 170.72C185.377 171.346 185.12 171.972 184.642 172.413C184.348 172.671 183.98 172.892 183.613 172.892C182.951 172.892 182.437 172.413 182.032 171.898C181.223 170.867 180.709 169.652 180.268 168.4C180.01 167.701 179.753 167.001 179.679 166.265C179.643 166.007 179.643 165.749 179.753 165.529C179.827 165.308 180.01 165.16 180.194 165.05C180.966 164.461 181.995 164.24 182.988 164.129C183.356 164.093 183.723 164.056 184.091 164.093C184.569 164.129 184.936 164.166 185.083 164.645C185.23 165.087 185.341 165.565 185.414 166.007C185.488 166.928 185.524 167.848 185.561 168.805Z",
    fill: "#FDFCFC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M178.65 184.121C178.65 183.974 178.43 183.9 178.356 184.047C178.025 184.563 177.621 185.078 177.07 185.336C176.371 185.667 175.526 185.557 174.827 185.226C174.129 184.894 173.54 184.379 172.952 183.863C172.401 183.385 171.849 182.869 171.298 182.391C170.269 181.507 169.092 180.697 167.732 180.66C165.6 180.66 164.277 181.323 163.652 183.017C162.99 181.36 161.667 180.734 159.608 180.771C158.248 180.771 157.072 181.581 156.042 182.501C155.491 182.98 154.939 183.495 154.388 183.974C153.8 184.489 153.212 185.005 152.513 185.336C151.815 185.667 150.969 185.778 150.271 185.447C149.719 185.189 149.315 184.71 148.984 184.158C148.911 184.011 148.69 184.084 148.69 184.232C148.617 186.036 148.984 187.95 150.271 189.202C151.263 190.196 152.624 190.748 154.02 190.932C155.417 191.116 156.814 190.932 158.174 190.675C160.159 190.27 162.181 189.496 163.394 187.876C163.505 187.729 163.615 187.582 163.689 187.398C163.762 187.508 163.836 187.656 163.946 187.766C165.159 189.386 167.218 190.159 169.166 190.564C170.526 190.859 171.96 191.006 173.32 190.822C174.717 190.638 176.077 190.085 177.07 189.091C178.356 187.84 178.724 185.925 178.65 184.121Z",
    fill: "#FDFCFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 180,
    width: 31,
    height: 12
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M178.65 184.121C178.65 183.974 178.43 183.9 178.356 184.047C178.025 184.563 177.621 185.078 177.07 185.336C176.371 185.667 175.526 185.557 174.827 185.226C174.129 184.894 173.54 184.379 172.952 183.863C172.401 183.385 171.849 182.869 171.298 182.391C170.269 181.507 169.092 180.697 167.732 180.66C165.6 180.66 164.277 181.323 163.652 183.017C162.99 181.36 161.667 180.734 159.608 180.771C158.248 180.771 157.072 181.581 156.042 182.501C155.491 182.98 154.939 183.495 154.388 183.974C153.8 184.489 153.212 185.005 152.513 185.336C151.815 185.667 150.969 185.778 150.271 185.447C149.719 185.189 149.315 184.71 148.984 184.158C148.911 184.011 148.69 184.084 148.69 184.232C148.617 186.036 148.984 187.95 150.271 189.202C151.263 190.196 152.624 190.748 154.02 190.932C155.417 191.116 156.814 190.932 158.174 190.675C160.159 190.27 162.181 189.496 163.394 187.876C163.505 187.729 163.615 187.582 163.689 187.398C163.762 187.508 163.836 187.656 163.946 187.766C165.159 189.386 167.218 190.159 169.166 190.564C170.526 190.859 171.96 191.006 173.32 190.822C174.717 190.638 176.077 190.085 177.07 189.091C178.356 187.84 178.724 185.925 178.65 184.121Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.688 183.532C163.725 183.606 163.762 183.679 163.799 183.753V183.569L163.688 183.532Z",
    fill: "#92B9E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M178.393 188.392C176.555 189.791 173.945 189.938 171.666 189.533C168.431 188.944 165.527 186.846 163.909 184.011C163.872 183.937 163.725 184.305 163.725 184.305C162.071 187.103 159.204 189.128 156.042 189.717C153.763 190.122 151.263 189.791 149.425 188.392L150.822 190.38L156.704 193.289L163.468 188.06L171.776 192.884L178.393 188.392Z",
    fill: "#92B9E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 180,
    width: 31,
    height: 12
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M178.65 184.121C178.65 183.974 178.43 183.9 178.356 184.047C178.025 184.563 177.621 185.078 177.07 185.336C176.371 185.667 175.526 185.557 174.827 185.226C174.129 184.894 173.54 184.379 172.952 183.863C172.401 183.385 171.849 182.869 171.298 182.391C170.269 181.507 169.092 180.697 167.732 180.66C165.6 180.66 164.277 181.323 163.652 183.017C162.99 181.36 161.667 180.734 159.608 180.771C158.248 180.771 157.072 181.581 156.042 182.501C155.491 182.98 154.939 183.495 154.388 183.974C153.8 184.489 153.212 185.005 152.513 185.336C151.815 185.667 150.969 185.778 150.271 185.447C149.719 185.189 149.315 184.71 148.984 184.158C148.911 184.011 148.69 184.084 148.69 184.232C148.617 186.036 148.984 187.95 150.271 189.202C151.263 190.196 152.624 190.748 154.02 190.932C155.417 191.116 156.814 190.932 158.174 190.675C160.159 190.27 162.181 189.496 163.394 187.876C163.505 187.729 163.615 187.582 163.689 187.398C163.762 187.508 163.836 187.656 163.946 187.766C165.159 189.386 167.218 190.159 169.166 190.564C170.526 190.859 171.96 191.006 173.32 190.822C174.717 190.638 176.077 190.085 177.07 189.091C178.356 187.84 178.724 185.925 178.65 184.121Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.424 182.243C160.049 182.943 160.968 183.458 161.924 183.716C162.88 183.974 163.946 184.048 164.938 183.937C165.784 183.827 166.593 183.643 167.328 183.274C168.063 182.906 168.688 182.354 169.019 181.654C169.203 181.286 169.276 180.881 169.129 180.55C168.945 180.108 168.394 179.887 167.879 179.814C167.181 179.703 166.482 179.85 165.784 179.961C164.166 180.182 162.549 180.071 160.931 179.924C160.49 179.887 160.012 179.85 159.571 179.961C158.285 180.329 158.799 181.544 159.424 182.243Z",
    fill: "#92B9E2"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M166.923 177.31C166.115 176.758 164.938 176.574 163.946 176.5C163.946 176.5 163.946 176.5 163.909 176.5C163.909 176.5 163.909 176.5 163.872 176.5C162.88 176.574 161.667 176.721 160.858 177.31C159.865 178.01 159.277 179.224 159.387 180.439C159.498 181.654 160.306 182.759 161.409 183.238C162.181 183.569 163.027 183.606 163.836 183.79H163.872H163.909C164.718 183.643 165.563 183.569 166.335 183.238C167.438 182.759 168.247 181.654 168.357 180.439C168.467 179.224 167.916 177.973 166.923 177.31Z",
    fill: "#FEA986"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 176,
    width: 10,
    height: 8
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M166.923 177.31C166.115 176.758 164.938 176.574 163.946 176.5C163.946 176.5 163.946 176.5 163.909 176.5C163.909 176.5 163.909 176.5 163.872 176.5C162.88 176.574 161.667 176.721 160.858 177.31C159.865 178.01 159.277 179.224 159.387 180.439C159.498 181.654 160.306 182.759 161.409 183.238C162.181 183.569 163.027 183.606 163.836 183.79H163.872H163.909C164.718 183.643 165.563 183.569 166.335 183.238C167.438 182.759 168.247 181.654 168.357 180.439C168.467 179.224 167.916 177.973 166.923 177.31Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M168.467 178.341C167.438 179.74 166.004 180.771 164.35 181.286C162.696 181.802 160.895 181.765 159.277 181.213C159.792 182.317 160.49 183.385 161.556 183.937C162.622 184.489 163.872 184.637 165.049 184.416C165.637 184.305 166.188 184.084 166.703 183.827C167.365 183.458 167.989 182.98 168.467 182.354C168.908 181.728 169.166 180.955 169.129 180.182C169.056 179.482 168.835 178.93 168.467 178.341Z",
    fill: "#D96955"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 176,
    width: 10,
    height: 8
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M166.923 177.31C166.115 176.758 164.938 176.574 163.946 176.5C163.946 176.5 163.946 176.5 163.909 176.5C163.909 176.5 163.909 176.5 163.872 176.5C162.88 176.574 161.667 176.721 160.858 177.31C159.865 178.01 159.277 179.224 159.387 180.439C159.498 181.654 160.306 182.759 161.409 183.238C162.181 183.569 163.027 183.606 163.836 183.79H163.872H163.909C164.718 183.643 165.563 183.569 166.335 183.238C167.438 182.759 168.247 181.654 168.357 180.439C168.467 179.224 167.916 177.973 166.923 177.31Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M160.748 178.267C160.637 178.414 160.564 178.562 160.527 178.709C160.49 178.856 160.564 179.077 160.674 179.151C160.858 179.261 161.079 179.224 161.262 179.114C161.593 178.93 161.851 178.635 162.181 178.525C162.328 178.488 162.512 178.451 162.696 178.414C162.88 178.378 163.1 178.304 163.211 178.157C163.358 178.009 163.431 177.789 163.394 177.604C163.358 177.384 163.174 177.236 162.953 177.163C162.145 176.905 161.226 177.604 160.748 178.267Z",
    fill: "#F9CBBB"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M163.982 162.215L138.617 158.865V159.859C138.617 161.258 138.948 162.62 139.536 163.872C139.831 163.872 147.771 167.333 164.019 167.296C180.231 167.333 188.171 163.872 188.502 163.872C189.09 162.62 189.421 161.258 189.421 159.859V158.865L163.982 162.215Z",
    fill: "#09122E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M163.983 163.356C178.012 163.356 189.384 161.428 189.384 159.049C189.384 156.67 178.012 154.741 163.983 154.741C149.954 154.741 138.581 156.67 138.581 159.049C138.581 161.428 149.954 163.356 163.983 163.356Z",
    fill: "#0F2A49"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 155.441L146.337 153.084L146.374 153.305L147.403 159.38C147.661 159.38 149.866 161.773 165.196 161.773C165.196 161.773 165.196 161.773 165.232 161.773C180.562 161.773 180.598 159.38 180.819 159.38L181.848 153.305L181.885 153.084L164.093 155.441Z",
    fill: "#F3BF20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 153,
    width: 36,
    height: 9
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 155.441L146.337 153.084L146.374 153.305L147.403 159.38C147.661 159.38 149.866 161.773 165.196 161.773C165.196 161.773 165.196 161.773 165.232 161.773C180.562 161.773 180.598 159.38 180.819 159.38L181.848 153.305L181.885 153.084L164.093 155.441Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.858 162.068C160.894 162.141 160.894 162.215 160.968 162.252C161.041 162.325 161.152 162.325 161.225 162.325C164.497 162.546 167.805 162.767 171.04 162.436C173.283 162.178 175.489 161.7 177.694 161.147C178.65 160.89 179.606 160.669 180.525 160.301C180.709 160.227 180.892 160.153 181.003 160.006C181.186 159.822 181.297 159.601 181.37 159.38C181.995 157.687 182.4 155.956 182.547 154.152C182.583 153.821 182.583 153.453 182.4 153.195C182.216 152.937 181.848 152.827 181.554 152.827C181.26 152.827 180.929 152.974 180.635 153.084C178.76 153.894 176.959 154.815 175.011 155.293C173.209 155.772 171.335 155.846 169.497 155.919C166.666 156.067 163.799 156.177 160.968 156.14C158.983 156.14 160.564 161.037 160.858 162.068Z",
    fill: "#B77E1C"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 156.692C173.899 156.692 181.848 155.077 181.848 153.084C181.848 151.092 173.899 149.476 164.093 149.476C154.287 149.476 146.337 151.092 146.337 153.084C146.337 155.077 154.287 156.692 164.093 156.692Z",
    fill: "#FADB4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_141_180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 149,
    width: 36,
    height: 8
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M164.093 156.692C173.899 156.692 181.848 155.077 181.848 153.084C181.848 151.092 173.899 149.476 164.093 149.476C154.287 149.476 146.337 151.092 146.337 153.084C146.337 155.077 154.287 156.692 164.093 156.692Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_141_180)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.298 157.208C174.827 156.876 178.54 156.471 181.407 154.373C181.738 154.152 182.032 153.857 182.216 153.526C182.62 152.679 182.106 151.612 181.26 151.17C180.415 150.728 179.422 150.838 178.54 151.17C177.657 151.501 176.849 151.98 175.966 152.311C175.158 152.643 174.275 152.827 173.43 152.9C171.041 153.084 172.07 155.404 171.298 157.208Z",
    fill: "#CE9427"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M182.547 132.467L163.946 132.945L145.345 132.467L147.881 152.274C148.212 152.495 153.101 154.999 163.799 155.036C163.835 155.036 163.872 155.036 163.946 155.036C163.983 155.036 164.019 155.036 164.093 155.036C174.79 154.999 179.716 152.495 180.01 152.274L182.547 132.467Z",
    fill: "#0D2745"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M163.982 134.933C174.235 134.933 182.547 133.829 182.547 132.467C182.547 131.104 174.235 130 163.982 130C153.73 130 145.418 131.104 145.418 132.467C145.418 133.829 153.73 134.933 163.982 134.933Z",
    fill: "#133A60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortuneWheelIcon);
export default __webpack_public_path__ + "static/media/fortune-wheel-icon.c5d92d0ecc87e8ced8bb69ccb2f0d689.svg";
export { ForwardRef as ReactComponent };